const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'stretch',
    width: '100%',
    padding: '40px 0',
  },
  collectionRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'stretch',
    width: '100%',
  },
  wrapper: {
    display: 'flex',
    padding: '0px 0px 24px 0',
    flexDirection: 'column',
    alignSelf: 'stretch',
    width: '100%',
    gap: 24,
    maxWidth: '1280px',
    alignItems: 'center',
  },
  editor: {
    width: '100%',
  },
  card: {
    borderRadius: '16px',
    /* Shadows/Light/Card */
    width: '100%',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.20), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
  },
})

export default styles
